function setFacetItemVisible(item, visible) {
    item.style.removeProperty("display");
    item.classList.toggle("visible", visible);
}

function setFacetShowMoreState(showMoreButton, expanded) {
    var showMoreLabel = showMoreButton.querySelector(".label-show-more");
    var showLessLabel = showMoreButton.querySelector(".label-show-less");
    showMoreButton.dataset.expanded = expanded ? "true" : "false";
    if (showMoreLabel) showMoreLabel.classList.toggle("hidden", expanded);
    if (showLessLabel) showLessLabel.classList.toggle("hidden", !expanded);
}

function syncFacetListFromSearch(facetBlock) {
    var input = facetBlock.querySelector(".facet-head-search-input");
    var showMoreButton = facetBlock.querySelector(".button-show-more");
    var items = facetBlock.querySelectorAll(".wizzy-facet-list-item");
    var query = input ? input.value.trim().toLowerCase() : "";

    items.forEach(function (item) {
        var term = item.getAttribute("data-term");
        term = (term == null ? "" : String(term)).toLowerCase();
        setFacetItemVisible(item, !query || term.indexOf(query) !== -1);
    });

    if (!showMoreButton) return;

    if (query || items.length <= 5) {
        showMoreButton.classList.toggle("hidden", items.length <= 5 || !!query);
        return;
    }

    showMoreButton.classList.remove("hidden");
    setFacetShowMoreState(showMoreButton, true);
}

function initFacetShowMore() {
    document.querySelectorAll(".wizzy-filters-facet-block").forEach(facetBlock => {
        const facetList = facetBlock.querySelector(".wizzy-facet-list")
          , showMoreButton = facetBlock.querySelector(".button-show-more");
        if (!facetList || !showMoreButton)
            return;
        const items = facetList.querySelectorAll(".wizzy-facet-list-item");
        items.forEach(item => setFacetItemVisible(item, true));
        if (items.length <= 5) {
            showMoreButton.classList.add("hidden");
            return
        }
        items.forEach((item, index) => setFacetItemVisible(item, index < 5));
        showMoreButton.classList.remove("hidden");
        setFacetShowMoreState(showMoreButton, false);
        showMoreButton.dataset.initialized !== "true" && (showMoreButton.dataset.initialized = "true",
        showMoreButton.addEventListener("click", () => {
            showMoreButton.dataset.expanded === "true" ? (items.forEach((item, index) => {
                setFacetItemVisible(item, index < 5);
            }
            ),
            setFacetShowMoreState(showMoreButton, false)) : (items.forEach(item => {
                setFacetItemVisible(item, true);
            }
            ),
            setFacetShowMoreState(showMoreButton, true))
        }
        ))
    }
    )
}

document.addEventListener("click", function (e) {
    var icon = e.target.closest(".facet-head-search-icon");
    if (!icon) return;
    var wrapper = icon.closest(".facet-search-wrapper");
    var block = icon.closest(".wizzy-filters-facet-block");
    if (!wrapper || !block) return;
    setTimeout(function () {
        if (wrapper.classList.contains("active")) return;
        syncFacetListFromSearch(block);
    }, 0);
});

document.addEventListener("keyup", function (e) {
    if (!e.target.classList.contains("facet-head-search-input")) return;
    var block = e.target.closest(".wizzy-filters-facet-block");
    if (!block) return;
    setTimeout(function () {
        syncFacetListFromSearch(block);
    }, 0);
});


window.onWizzyScriptLoaded = function () {
  var events = window.wizzyConfig.events;
  var allowed = events.allowedEvents;





  function attrValues(product, id) {
    var attrs = product.attributes || [];
    var out = [];
    for (var i = 0; i < attrs.length; i++) {
      if (attrs[i].id !== id) continue;
      var values = attrs[i].values || [];
      for (var j = 0; j < values.length; j++) {
        var val = values[j].value;
        if (Array.isArray(val)) {
          for (var k = 0; k < val.length; k++) out.push(val[k]);
        } else if (val != null) {
          out.push(val);
        }
      }
    }
    return out;
  }

  function toNumber(val) {
    if (val == null || val === '') return null;
    if (typeof val === 'number') return isNaN(val) ? null : val;
    var n = parseFloat(String(val).replace(/,/g, ''));
    return isNaN(n) ? null : n;
  }

  function collectNumbers(val) {
    if (val == null) return [];
    var list = Array.isArray(val) ? val : [val];
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var n = toNumber(list[i]);
      if (n != null) out.push(n);
    }
    return out;
  }

  function minMax(nums) {
    if (!nums.length) return { min: 0, max: 0 };
    var min = nums[0];
    var max = nums[0];
    for (var i = 1; i < nums.length; i++) {
      if (nums[i] < min) min = nums[i];
      if (nums[i] > max) max = nums[i];
    }
    return { min: min, max: max };
  }

  function cents(amount) {
    return Math.round(Number(amount || 0) * 100);
  }

  function formatMoney(dollars) {
    var c = cents(dollars);
    var format =
      (window.theme && theme.settings && theme.settings.money_format) || '${{amount}}';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(c, format);
    }
    var symbol =
      (window.wizzyConfig.store &&
        window.wizzyConfig.store.currency &&
        window.wizzyConfig.store.currency.symbol) ||
      '$';
    var n = Number(Number(dollars || 0).toFixed(2));
    var formatted = typeof n.formatMoney === 'function' ? n.formatMoney() : n.toFixed(2);
    return symbol + formatted;
  }

  function reorderSuggestionsOnly(suggestions) {
    const recent = [];
    const trending = [];
    const others = [];

    let recentIndex = 0;

    suggestions.forEach(function (item) {
        if (item.group === "recentSearches") {
            if (!item.isHead) {
                item.index = recentIndex++;
            }

            recent.push(item);
        } else if (item.group === "trendingSearches") {
            trending.push(item);
        } else {
            others.push(item);
        }
    });

    return [...recent, ...trending, ...others];
  }

  events.registerEvent(allowed.BEFORE_INIT, function (data) {
      data.filters.configs.layout = "v1";
      data.search.configs.pagination.appendInExistingList = !0;
      data.filters.configs.keepOpenedInMobileAfterApply = !0;
      data.search.configs.facets.leftFacets.mobileCollapsible = !0;
      return data;
  });

  events.registerEvent(allowed.BEFORE_LAZY_INIT, function (data) {
      data.filters.configs.layout = "v1";
      data.filters.configs.keepOpenedInMobileAfterApply = !0;
      data.search.configs.facets.leftFacets.mobileCollapsible = !0;
      return data;
  });
  
  events.registerEvent(
    allowed.BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER,
    function (data) {

        // if (data.isForDefault === true) {
        //     data.suggestions = reorderSuggestionsOnly(data.suggestions);
        // }

        return data;
    }
  );

  events.registerEvent(allowed.BEFORE_SEARCH_EXECUTED, function (data) {
    const closeButton = document.querySelector(
      '.drawer__button-close.button-reset.no-js-hidden.js-btn-close-drawer.menu-is-open'
    );

    if (closeButton) {
      closeButton.click();
    }
    const html = document.documentElement;

    if (html.classList.contains('df-fix-layout')) {
        html.classList.remove('df-fix-layout');
    }

  return data;
  });
  events.registerEvent(allowed.VIEW_RENDERED, function (data) {
    initFacetShowMore();
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.wizzy-search-filters-left .drawer__row--buttons .wizzy-apply-all-button')) return;
        e.preventDefault();
        var bg = document.querySelector('.wizzy-filters-bg');
        if (bg) bg.click();
      });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.wizzy-search-filters-left .drawer__button-close')) return;
        e.preventDefault();
        var bg = document.querySelector('.wizzy-filters-bg');
        if (bg) bg.click();
      });


      

      return data;
  });
  events.registerEvent(allowed.AFTER_PRODUCTS_TRANSFORMED, function (products) {
    products.forEach(function (product) {
      var handles = attrValues(product, 'product_handle');
      if (handles.length) product.handle = handles[0];

      // Wizzy top-level sellingPrice is one number; variant range lives on product_variant_prices.
      var selling = collectNumbers(attrValues(product, 'product_variant_prices'));
      if (!selling.length) selling = collectNumbers(product.sellingPrice);
      if (!selling.length) selling = collectNumbers(product.finalPrice);

      var compareAt = collectNumbers(product.price).filter(function (n) {
        return n > 0;
      });
      var range = minMax(selling);
      var compareRange = minMax(compareAt);
      var priceVaries = cents(range.min) !== cents(range.max);
      var onSale =
        (compareAt.length && compareRange.max > range.max) ||
        (compareAt.length && compareRange.min > range.min) ||
        toNumber(product.discountPercentage) > 0 ||
        toNumber(product.discount) > 0;

      var labels = window.wizzyThemePrice || {};
      product.priceVaries = priceVaries;
      product.onSale = !!onSale;
      product.priceClass =
        'price' +
        (onSale ? ' price--on-sale' : '') +
        (product.inStock === false ? ' price--sold-out' : '');
      product.priceRegularLabel = labels.priceRegular || 'Regular price';
      product.priceSaleLabel = labels.priceSale || 'Sale price';
      product.priceFromLabel = labels.priceFrom || 'From';
      product.priceMinLabel = labels.priceMin || 'Minimum price';
      product.priceMaxLabel = labels.priceMax || 'Maximum price';
      product.moneyFormat = labels.moneyFormat || '${{amount}}';
      product.priceMinDisplay = formatMoney(range.min);
      product.priceMaxDisplay = formatMoney(range.max);
      product.compareAtDisplay = formatMoney(compareRange.max || compareRange.min);
      product.dataPrice = String(cents(range.min));
      product.dataPriceMin = String(cents(range.min));
      product.dataPriceMax = String(cents(range.max));
      product.dataCompareAtPrice = compareAt.length ? String(cents(compareRange.max)) : '';
      product.dataCompareAtPriceMin = compareAt.length ? String(cents(compareRange.min)) : '0';
      product.dataCompareAtPriceMax = compareAt.length ? String(cents(compareRange.max)) : '0';

      var reviewAvg = collectNumbers(attrValues(product, 'product_review_average_bayreviews'))[0];
      var reviewCount = collectNumbers(attrValues(product, 'product_review_count_bayreviews'))[0];
      if (reviewAvg == null) reviewAvg = 0;
      if (reviewCount == null) reviewCount = 0;
      reviewCount = Math.round(reviewCount);

      product.reviewRatingDisplay = (Math.round(reviewAvg * 10) / 10).toFixed(1);
      product.reviewCountDisplay = String(reviewCount);
      product.reviewCountLabel = reviewCount === 1 ? 'review' : 'reviews';
      product.reviewStars = [];
      for (var s = 0; s < 5; s++) {
        var fill = Math.min(1, Math.max(0, reviewAvg - s));
        product.reviewStars.push({
          clipPath: 'inset(0px ' + ((1 - fill) * 100).toFixed(4) + '% 0px 0px)'
        });
      }
    });

    return products;
  });

  

};
